import React, { useState } from 'react';
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { PackageIcon, PlusIcon, FilterIcon, SearchIcon, DownloadIcon, BoxIcon, CheckCircleIcon, ShoppingBagIcon, TruckIcon, TagIcon, BarChart2Icon } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
const Inventory = () => {
  const [activeTab, setActiveTab] = useState('all');
  const inventoryItems = [{
    id: 1,
    name: 'iPhone 13 Pro',
    sku: 'IP13P-256-GR-A',
    grade: 'A',
    storage: '256GB',
    color: 'Graphite',
    price: 649.99,
    status: 'In Stock',
    location: 'Warehouse A',
    dateAdded: '2023-07-15'
  }, {
    id: 2,
    name: 'Samsung Galaxy S22',
    sku: 'SGS22-128-BK-B',
    grade: 'B',
    storage: '128GB',
    color: 'Black',
    price: 429.99,
    status: 'In Stock',
    location: 'Warehouse B',
    dateAdded: '2023-07-12'
  }, {
    id: 3,
    name: 'Google Pixel 6',
    sku: 'GP6-128-BL-A',
    grade: 'A',
    storage: '128GB',
    color: 'Blue',
    price: 399.99,
    status: 'Reserved',
    location: 'Warehouse A',
    dateAdded: '2023-07-10'
  }, {
    id: 4,
    name: 'iPhone 12',
    sku: 'IP12-64-WH-B',
    grade: 'B',
    storage: '64GB',
    color: 'White',
    price: 379.99,
    status: 'In Stock',
    location: 'Warehouse C',
    dateAdded: '2023-07-08'
  }, {
    id: 5,
    name: 'OnePlus 10 Pro',
    sku: 'OP10P-256-GR-C',
    grade: 'C',
    storage: '256GB',
    color: 'Green',
    price: 349.99,
    status: 'Sold',
    location: 'Warehouse B',
    dateAdded: '2023-07-05'
  }];
  const inventoryStats = {
    totalDevices: 162,
    totalValue: '$67,890',
    inStock: 128,
    reserved: 22,
    sold: 12,
    pendingShipment: 8
  };
  return <div className="space-y-6" data-id="element-929">
      <div className="flex items-center justify-between" data-id="element-930">
        <div data-id="element-931">
          <h1 className="text-2xl font-bold" data-id="element-932">Inventory Management</h1>
          <p className="text-sm text-muted-foreground" data-id="element-933">
            Manage your device inventory, track stock levels, and monitor status
          </p>
        </div>
        <div className="flex space-x-2" data-id="element-934">
          <Button variant="outline" data-id="element-935">
            <DownloadIcon className="mr-2 h-4 w-4" data-id="element-936" />
            Export
          </Button>
          <Button data-id="element-937">
            <PlusIcon className="mr-2 h-4 w-4" data-id="element-938" />
            Add Device
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-939">
        <Card data-id="element-940">
          <CardContent className="p-4" data-id="element-941">
            <div className="flex items-center justify-between" data-id="element-942">
              <div data-id="element-943">
                <p className="text-sm text-muted-foreground" data-id="element-944">Total Devices</p>
                <p className="text-2xl font-bold" data-id="element-945">
                  {inventoryStats.totalDevices}
                </p>
              </div>
              <BoxIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-946" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-947">
          <CardContent className="p-4" data-id="element-948">
            <div className="flex items-center justify-between" data-id="element-949">
              <div data-id="element-950">
                <p className="text-sm text-muted-foreground" data-id="element-951">Total Value</p>
                <p className="text-2xl font-bold" data-id="element-952">
                  {inventoryStats.totalValue}
                </p>
              </div>
              <TagIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-953" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-954">
          <CardContent className="p-4" data-id="element-955">
            <div className="flex items-center justify-between" data-id="element-956">
              <div data-id="element-957">
                <p className="text-sm text-muted-foreground" data-id="element-958">In Stock</p>
                <p className="text-2xl font-bold" data-id="element-959">{inventoryStats.inStock}</p>
              </div>
              <CheckCircleIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-960" />
            </div>
          </CardContent>
        </Card>
        <Card data-id="element-961">
          <CardContent className="p-4" data-id="element-962">
            <div className="flex items-center justify-between" data-id="element-963">
              <div data-id="element-964">
                <p className="text-sm text-muted-foreground" data-id="element-965">
                  Pending Shipment
                </p>
                <p className="text-2xl font-bold" data-id="element-966">
                  {inventoryStats.pendingShipment}
                </p>
              </div>
              <TruckIcon className="h-8 w-8 text-muted-foreground/30" data-id="element-967" />
            </div>
          </CardContent>
        </Card>
      </div>
      <Card data-id="element-968">
        <CardHeader className="pb-2" data-id="element-969">
          <div className="flex items-center justify-between" data-id="element-970">
            <CardTitle data-id="element-971">Inventory List</CardTitle>
            <div className="flex space-x-2" data-id="element-972">
              <div className="relative" data-id="element-973">
                <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" data-id="element-974" />
                <input type="text" placeholder="Search devices..." className="pl-10 pr-4 py-2 rounded-md border bg-background text-sm w-64" data-id="element-975" />
              </div>
              <Button variant="outline" size="icon" data-id="element-976">
                <FilterIcon className="h-4 w-4" data-id="element-977" />
              </Button>
            </div>
          </div>
          <CardDescription data-id="element-978">
            View and manage your current inventory
          </CardDescription>
        </CardHeader>
        <CardContent data-id="element-979">
          <Tabs defaultValue="all" value={activeTab} onValueChange={setActiveTab} data-id="element-980">
            <TabsList className="mb-4" data-id="element-981">
              <TabsTrigger value="all" data-id="element-982">All Devices</TabsTrigger>
              <TabsTrigger value="instock" data-id="element-983">In Stock</TabsTrigger>
              <TabsTrigger value="reserved" data-id="element-984">Reserved</TabsTrigger>
              <TabsTrigger value="sold" data-id="element-985">Sold</TabsTrigger>
            </TabsList>
            <TabsContent value="all" className="space-y-4" data-id="element-986">
              <div className="overflow-x-auto" data-id="element-987">
                <table className="w-full" data-id="element-988">
                  <thead data-id="element-989">
                    <tr className="border-b" data-id="element-990">
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-991">
                        Device
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-992">
                        SKU
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-993">
                        Grade
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-994">
                        Price
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-995">
                        Status
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-996">
                        Location
                      </th>
                      <th className="text-left py-3 px-4 font-medium text-muted-foreground" data-id="element-997">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody data-id="element-998">
                    {inventoryItems.map(item => <tr key={item.id} className="border-b hover:bg-muted/50" data-id="element-999">
                        <td className="py-3 px-4" data-id="element-1000">
                          <div data-id="element-1001">
                            <p className="font-medium" data-id="element-1002">{item.name}</p>
                            <p className="text-xs text-muted-foreground" data-id="element-1003">
                              {item.storage} • {item.color}
                            </p>
                          </div>
                        </td>
                        <td className="py-3 px-4 text-sm" data-id="element-1004">{item.sku}</td>
                        <td className="py-3 px-4" data-id="element-1005">
                          <Badge variant={item.grade === 'A' ? 'success' : item.grade === 'B' ? 'warning' : 'default'} data-id="element-1006">
                            {item.grade}
                          </Badge>
                        </td>
                        <td className="py-3 px-4 font-medium" data-id="element-1007">${item.price}</td>
                        <td className="py-3 px-4" data-id="element-1008">
                          <Badge variant={item.status === 'In Stock' ? 'success' : item.status === 'Reserved' ? 'warning' : 'secondary'} data-id="element-1009">
                            {item.status}
                          </Badge>
                        </td>
                        <td className="py-3 px-4 text-sm" data-id="element-1010">{item.location}</td>
                        <td className="py-3 px-4" data-id="element-1011">
                          <Button variant="ghost" size="sm" data-id="element-1012">
                            View
                          </Button>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </TabsContent>
            <TabsContent value="instock" data-id="element-1013">
              <div className="flex items-center justify-center h-40 border rounded-md bg-muted/30" data-id="element-1014">
                <p className="text-muted-foreground" data-id="element-1015">
                  In Stock devices will be displayed here
                </p>
              </div>
            </TabsContent>
            <TabsContent value="reserved" data-id="element-1016">
              <div className="flex items-center justify-center h-40 border rounded-md bg-muted/30" data-id="element-1017">
                <p className="text-muted-foreground" data-id="element-1018">
                  Reserved devices will be displayed here
                </p>
              </div>
            </TabsContent>
            <TabsContent value="sold" data-id="element-1019">
              <div className="flex items-center justify-center h-40 border rounded-md bg-muted/30" data-id="element-1020">
                <p className="text-muted-foreground" data-id="element-1021">
                  Sold devices will be displayed here
                </p>
              </div>
            </TabsContent>
          </Tabs>
        </CardContent>
        <CardFooter className="border-t" data-id="element-1022">
          <div className="text-sm text-muted-foreground" data-id="element-1023">
            Showing 5 of {inventoryStats.totalDevices} devices
          </div>
          <div className="ml-auto flex space-x-2" data-id="element-1024">
            <Button variant="outline" size="sm" disabled data-id="element-1025">
              Previous
            </Button>
            <Button variant="outline" size="sm" data-id="element-1026">
              Next
            </Button>
          </div>
        </CardFooter>
      </Card>
    </div>;
};
export default Inventory;